module.exports = __webpack_public_path__ + "img/sale-02.0380cb63.svg";